<template>
  <div ref="observerTarget">
    <slot />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const props = defineProps({
  advertising: {
    type: Number,
    default: 0,
  },
});

const observerTarget = ref(null);

// Callback function that is executed when the element comes into view
const logAdvertisingInView = (entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      axios
        .post(`/web-api/advertising/${props.advertising}/log`, {
          type: "inView",
        })
        .catch(() => {
          // Impression logging is best-effort; ignore network/CSRF failures.
        });

      // stop observing after the event has been triggered
      observer.unobserve(entry.target);
    }
  });
};

onMounted(() => {
  // Ensure the Intersection Observer API is supported
  if ("IntersectionObserver" in window) {
    // Create the observer with the callback function and options
    const options = {
      root: null, // observing relative to the viewport
      rootMargin: "0px",
      threshold: 0.1, // Trigger when at least 10% of the element is visible
    };
    const observer = new IntersectionObserver(logAdvertisingInView, options);

    // Start observing the target element
    if (observerTarget.value) {
      observer.observe(observerTarget.value);
    }
  }
});

// Disabled Jan 2026, during switch to VueJs3 and the removal of inline templates
/* const logAdvertisingClick = (event) => {
  axios.post(`/web-api/advertising/${props.advertising}/log`, {
    type: "click",
  });

  // Resolve the <a> element from the event path
  let target = event.target;
  while (target && target.nodeName !== "A") {
    target = target.parentNode;
  }

  if (target && target.href) {
    let url = target.href;
    if (url.startsWith("https://www.used-design.com")) {
      window.location.href = url; // open in same tab (cause of browser popup blocker policies)
    } else {
      window.open(url, "_blank");
    }
  }
}; */
</script>
